import React from "react";
import FaceCamera from "../../face/FaceCamera";
import FaceUi from "../../face/FaceUi";
import styles from "../../../../styles/index.module.css";
import { FaceCallback } from "@innovatrics/dot-face-auto-capture/.";
import commonStyles from "../../../../styles/common.module.css";
import Image from "../../../common/Image";
import ProcessingDescription from "../../common/ProcessingDescription";
import { useTranslation } from "react-i18next";

interface Props {
  onPhotoTaken: FaceCallback;
  onError: (error: Error) => void;
  photoUrl:string | undefined
  processing:boolean
}

const PassiveLiveness = ({ onPhotoTaken, onError,photoUrl,processing }: Props) => {
  const handlePhotoTaken: FaceCallback = async (imageData, content) => {
    onPhotoTaken(imageData, content);
  };
  const {t} = useTranslation();

  const faceUIInstructions = {
    candidate_selection:t('liveness.capture.staystill'),
    face_too_close:t('liveness.capture.moveback'),
    face_too_far:t('liveness.capture.movecloser'),
    face_centering:t('liveness.capture.centeryourface'),
    face_not_present:t('liveness.capture.positionyourface'),
    left_eye_not_present:t('liveness.capture.positionyourface'),
    right_eye_not_present:t('liveness.capture.positionyourface'),
    mouth_not_present:t('liveness.capture.positionyourface'),
    sharpness_too_low:t('liveness.capture.turntolight'),
    brightness_too_low:t('liveness.capture.turntolight'),
    brightness_too_high:t('liveness.capture.lesslight'),
    device_pitched:t('liveness.capture.holdateyelevel')
}
  return (
    <div className={commonStyles.passiveLivenessContainer}>
      <span className={commonStyles.header}>{t('liveness.passive.capture.header')}</span>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          flexDirection:"column",
          gap: "5px",
        }}
      >
        <div className={styles.container}>
          <FaceCamera
            cameraFacing="user"
            onPhotoTaken={handlePhotoTaken}
            onError={onError}
          />
          <FaceUi
            showCameraButtons
            appStateInstructions={{
              loading: {
                text: t('liveness.passive.capture.loading'),
                visible: true,
              },
              waiting: {
                text: t('processing'),
                visible: true,
              },
            }}
            instructions={faceUIInstructions}
          />
           <div className={commonStyles.popup}> 
           {photoUrl && (<Image src={photoUrl} className={commonStyles.popupImg}></Image>)}
           </div>
        </div>
        {processing && photoUrl && (<ProcessingDescription content={t('liveness.capture.processing.description')} />)}
      </div>
    </div>
  );
};

export default PassiveLiveness;
